import React from "react";

import { CloseIcon } from "@pages/casino/assets/icons";
import { Modal } from "@pages/casino/components";

import {
	CloseIconOverlay,
	DropdownContainer,
	DropdownHeader,
	DropdownItem,
	DropdownList,
	FilterHeader,
	ItemWrapper,
	ModalItem,
	ModalItemsWrapper,
} from "./element.js";

import useController from "./useController";

const DROPDOWN_ITEMS_LENGTH = 45;

const GridDropdown = ({
	items,
	placeholder,
	onSelect,
	name,
	activeTab,
	onClose,
	isModalDisabled,
	value,
	"data-testid": dataTestId,
}) => {
	const {
		refs: { headerRef },
		helpers: { translate },
		state: { open, selectedItem, isMobile, isTablet },
		handlers: { handleSelect, handleToggle },
	} = useController({
		onSelect,
		onClose,
		value,
	});

	return (
		<DropdownContainer
			className={name || ""}>
			<DropdownHeader
				data-testid={dataTestId}
				onClick={handleToggle}
				open={open}>
				<p ref={headerRef}>{placeholder}</p>
			</DropdownHeader>
			{isMobile ||
			isTablet ||
			(isModalDisabled ? false : DROPDOWN_ITEMS_LENGTH < items?.length) ? (
				<Modal
					position={"top"}
					hasOverflow
					open={open}
					onClose={handleToggle}>
					<ModalItemsWrapper>
						<FilterHeader>
							{activeTab ? translate("casino." + activeTab) : placeholder}
						</FilterHeader>
						<ItemWrapper className="item-wrapper">
							{items?.map((item) => (
								<ModalItem
									key={item.key}
									isSelected={item?.key === selectedItem?.key}
									onClick={() => handleSelect(item)}>
									{item.value}
								</ModalItem>
							))}
							<CloseIconOverlay />
							<CloseIcon
								data-testid="grid-dropdown-modal-close-icon"
								className="modal-close-icon"
								onClick={handleToggle}
							/>
						</ItemWrapper>
					</ModalItemsWrapper>
				</Modal>
			) : (
				<DropdownList open={open}>
					{items?.map((item) => (
						<DropdownItem
							data-testid={`grid-dropdown-item-${item.key}`}
							key={item.key}
							isSelected={item?.key === selectedItem?.key}
							onClick={() => handleSelect(item)}>
							{item.value}
						</DropdownItem>
					))}
				</DropdownList>
			)}
		</DropdownContainer>
	);
};

export default GridDropdown;
